import email from '../components/BuildingBlocks/Misc/emailSupportText';

export function contactUs() {
  window.location.href = `mailto:${email.to}?subject=${email.subject.replace(
    ' ',
    '%20',
  )}&body=${email.body.replace(' ', '%20')}`;
}
